"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateRobotsTxt = generateRobotsTxt;
exports.createRobotsHandler = createRobotsHandler;
/**
 * Generates robots.txt content based on environment configuration
 *
 * @param allowIndexing - Whether to allow search engine indexing
 * @param siteUrl - The site URL for sitemap reference (optional)
 * @returns The robots.txt content string
 */
function generateRobotsTxt(allowIndexing, siteUrl) {
    if (allowIndexing) {
        return `# Allow all web crawlers
User-agent: *
Allow: /

# Sitemap location
Sitemap: ${siteUrl || ""}/sitemap.xml
`;
    }
    return `# Disallow all web crawlers (indexing not enabled)
User-agent: *
Disallow: /
`;
}
/**
 * Creates a Next.js API handler for robots.txt
 *
 * Controls search engine indexing based on environment variables.
 * Set the allow indexing env var to "true" to allow crawlers (production only).
 * All other values or missing variable will block all crawlers.
 *
 * @param config - Optional configuration for environment variable names
 * @param config.allowIndexingEnvVar - Env var name for allow indexing flag (default: "ROBOTS_ALLOW_INDEXING")
 * @param config.siteUrlEnvVar - Env var name for site URL (default: "NEXT_PUBLIC_SITE_URL")
 * @returns Next.js API handler function
 *
 * @example
 * // pages/api/robots.ts
 * import { createRobotsHandler } from "@orlandohealth/utils";
 * export default createRobotsHandler();
 *
 * @example
 * // With custom env var names
 * import { createRobotsHandler } from "@orlandohealth/utils";
 * export default createRobotsHandler({
 *   allowIndexingEnvVar: "ALLOW_CRAWLERS",
 *   siteUrlEnvVar: "SITE_URL"
 * });
 */
function createRobotsHandler(config = {}) {
    const { allowIndexingEnvVar = "ROBOTS_ALLOW_INDEXING", siteUrlEnvVar = "NEXT_PUBLIC_SITE_URL", } = config;
    return function handler(_req, res) {
        const allowIndexing = process.env[allowIndexingEnvVar] === "true";
        const siteUrl = process.env[siteUrlEnvVar];
        const robotsTxt = generateRobotsTxt(allowIndexing, siteUrl);
        res.setHeader("Content-Type", "text/plain");
        res.setHeader("Cache-Control", "public, s-maxage=3600, stale-while-revalidate=86400");
        res.status(200).send(robotsTxt);
    };
}
